import React from 'react';
import { Col, Modal, Spin } from 'antd';
import { Formik } from 'formik';
import { Form, Input } from 'formik-antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import FormControl from '~/components/Form/FormControl';
import { ModalFooter } from '~/components/Modal';
import Row from '~/components/Row';
import { createArea, updateArea } from '~/services/hooks/areas';

export default function AreaForm({ selectedRecord, visible, onClose, onUpdateItem, onInsertItem }) {
  const initialValues = {
    id: null,
    name: '',
  };

  const Area = { ...initialValues, ...selectedRecord };
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSave = async values => {
    setLoading(true);
    if (values.id !== null) {
      const data = await updateArea(values);
      onUpdateItem(data);
    } else {
      const data = await createArea(values);
      onInsertItem(data);
    }
    onClose();
    setLoading(false);
  };

  const areachema = Yup.object().shape({
    name: Yup.string().required(),
  });

  return (
    <Formik initialValues={Area} enableReinitialize onSubmit={handleSave} validationSchema={areachema}>
      {({ errors, isSubmitting, submitForm, resetForm, values }) => (
        <Modal
          width="850px"
          title={values.id !== null ? t('screens:area.btnEdit') : t('screens:area.btnNew')}
          onCancel={onClose}
          afterClose={resetForm}
          open={visible}
          loading={loading || isSubmitting}
          footer={
            <ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} cancelColor="default" />
          }
        >
          <Spin spinning={loading || isSubmitting}>
            <Form>
              <Row>
                <Col span={24}>
                  <FormControl field="name" label={t('screens:area.data.name')} required error={errors.name}>
                    <Input name="name" />
                  </FormControl>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
